import SimpleInput from 'ui/input';
import { useState } from 'react';
import EyeHide from 'assets/icons/EyeHide';
import EyeShow from 'assets/icons/EyeShow';
import { Form, Formik } from 'formik';
import { useLoginWebMutation } from '../api/mutations/generated/Login';
import { setTokens } from 'app/config/auth';
import { saveLoginData } from '../lib/utils';
import { userFullName } from 'utils/helpers/userFullName';
import { errorHandler } from 'utils/helpers/errorHandler';
import { useNavigate } from 'react-router-dom';
import { errorToast } from 'utils/helpers/notify';
import { useMeShortlyLazyQuery } from 'pages/main/api/queries/generated/MeShortly';
import { REDIRECT_PAGE } from 'utils/helpers/constVariables';
import { convertPhoneToString } from 'utils/helpers/convertPhone';
import { IMask } from 'react-imask';

const LoginForm = () => {
  const navigate = useNavigate();
  const [loginMutation, { loading }] = useLoginWebMutation();
  const [showPassword, setShowPassword] = useState(false);
  const [load] = useMeShortlyLazyQuery();
  const pageFrom = localStorage.getItem(REDIRECT_PAGE);

  const masked = IMask.createMask({ mask: '+7 (000) 000-00-00' });

  const handleSubmit = (values: { phone: string; password: string }) => {
    loginMutation({ variables: { input: { phone: convertPhoneToString(values.phone), password: values.password } } })
      .then(response => {
        const data = response.data?.loginWeb;
        if (data?.user) {
          setTokens({
            accessToken: data.accessToken,
            refreshToken: data.refreshToken,
          });
          load().then(meRes => {
            if (meRes.data) {
              const user = meRes.data.meShortly;
              localStorage.setItem('me', JSON.stringify(user));
              saveLoginData({
                name: userFullName(user),
                phone: values.phone,
                password: values.password,
                role: user.role,
              });
            }
            if (pageFrom) {
              navigate(pageFrom);
              localStorage.removeItem(REDIRECT_PAGE);
            } else {
              navigate('/');
            }
          });
        }
      })
      .catch(e => {
        errorToast(errorHandler(e));
      });
  };

  return (
    <Formik initialValues={{ phone: '', password: '' }} onSubmit={handleSubmit}>
      {({ values, handleChange, setFieldValue, errors, touched }) => (
        <Form className="flex flex-col w-[385px] px-12 py-12 bg-white rounded-2xl shadow-lg mb-6">
          <h2 className="mb-12 H2">Вход</h2>
          <div className="flex flex-col gap-y-3 mb-8">
            <SimpleInput
              label="Телефон"
              placeholder="Введите ваш номер телефона"
              name="phone"
              type="text"
              onKeyUp={e => {
                const input = e.target as HTMLInputElement;
                masked.resolve(input.value);
                input.value = masked.value;
                setFieldValue('phone', masked.value);
              }}
              onPaste={event => {
                event.preventDefault();
                const paste = event.clipboardData.getData('text');
                masked.resolve(paste);
                setFieldValue('phone', masked.value);
              }}
              maxLength={18}
              onChange={handleChange}
              value={values.phone}
              error={touched.phone && errors.phone ? errors.phone : undefined}
            />
            <div className="relative">
              <SimpleInput
                label="Пароль"
                placeholder="Введите ваш пароль"
                name="password"
                type={showPassword ? 'text' : 'password'}
                onChange={handleChange}
                value={values.password}
                error={touched.password && errors.password ? errors.password : undefined}
              />
              <button
                type="button"
                className="absolute right-3 bottom-[16px] translate-y-1/2 text-smena_text-helper"
                onClick={() => setShowPassword(v => !v)}
              >
                {showPassword ? <EyeHide /> : <EyeShow />}
              </button>
            </div>
          </div>

          <button type="submit" className="btn-primary mb-8" disabled={!values.phone || !values.password || loading}>
            {loading ? 'Загрузка' : 'Войти'}
          </button>
          <p className="Body2  text-smena text-[13px] ">
            Нажимая кнопку «Войти», вы соглашаетесь <br />с{' '}
            <a href="/offer" className="link" target="_blank">
              обработкой персональных данных, политикой конфиденциальности
            </a>{' '}
            и <br />
            <a href="/offer" className="link" target="_blank">
              условиям оферты.
            </a>
          </p>
        </Form>
      )}
    </Formik>
  );
};

export default LoginForm;
